import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetProfile = createAsyncThunk(
  "getProfileData/GetProfile",
  async (_, thunkAPI) => {
    try {
      const Token = localStorage.getItem("loginData");
      const response = await axios.get(endPoint.GetProfile, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.error("Error in GetProfile thunk:", error.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetProfileSlice = createSlice({
  name: "GetProfileData",
  initialState: {
    GetProfileData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetProfile.fulfilled, (state, action) => {
        state.GetProfileData = action.payload;
      })
      .addCase(GetProfile.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetProfileSlice.reducer;
